import { render, staticRenderFns } from "./FrzProcessResumeKG.vue?vue&type=template&id=693a04b8"
import script from "./FrzProcessResumeKG.vue?vue&type=script&lang=js"
export * from "./FrzProcessResumeKG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports